const DEEP_LINK_KEY = 'kueski_dl';

export const deepLink = {
  get: () => {
    const storedDeepLink = localStorage.getItem(DEEP_LINK_KEY);

    localStorage.removeItem(DEEP_LINK_KEY);

    return storedDeepLink;
  },
  set: (url?: string) => (url
    ? localStorage.setItem(DEEP_LINK_KEY, url.toString())
    : localStorage.removeItem(DEEP_LINK_KEY)),
};
